import React from 'react';
import PropTypes from 'prop-types';

export default class CardSimpleHeader extends React.Component {

  renderOptions(){
    if (!this.props.options){
      return null;
    }
    return this.props.options;
  }

  render() {
    return (
      <div className="header">
        <h2>{this.props.title.toUpperCase()}</h2>
        <div >
          {this.renderOptions()}
        </div>
      </div>
    );
  }

}


CardSimpleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.any,
};

CardSimpleHeader.defaultProps = {
  title: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/CardSimpleHeader.js